import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Autocomplete from "./autocomplete";
import { useQuery, QueryResponseHandler } from "components/graphql";

export const DEFAULT_AUTOCOMPLETE_LIMIT = 20;

const getQuery = ({ gqlQuery, variables }) => ({
  query: gqlQuery,
  variables: { offset: 0, limit: DEFAULT_AUTOCOMPLETE_LIMIT, ...variables },
});

const AutocompleteConnected = ({ gqlQuery, getElementsFromDataHandler, variables = {}, ...props }) => {
  const query = useMemo(() => getQuery({ gqlQuery, variables }), [gqlQuery, variables]);
  const { data, loading, error } = useQuery(query);

  const elements = getElementsFromDataHandler(data);

  return (
    <QueryResponseHandler error={error} loading={loading} elements={elements}>
      <Autocomplete suggestions={elements ? elements.items : []} {...props} />
    </QueryResponseHandler>
  );
};

AutocompleteConnected.propTypes = {
  /**
   * Función que obtiene el texto a mostrar en el autocomplete a partir del elemento.
   **/
  getSuggestionValue: PropTypes.func.isRequired,
  /**
   * Variables de la query graphql
   **/
  variables: PropTypes.object,
  /**
   * Query graphql que se utilizará para obtener los elementos
   **/
  gqlQuery: PropTypes.object.isRequired,
  /**
   * Función que obtiene los elementos a representar de los datos devueltos por el servidor
   **/
  getElementsFromDataHandler: PropTypes.func.isRequired,
  /**
   * Placeholder del input del autocomplete.
   **/
  placeholder: PropTypes.string,
  /**
   * Label del input del autocomplete.
   **/
  label: PropTypes.string,
  /**
   * Nombre del input
   **/
  name: PropTypes.string,
  /**
   * Callback que se llama cuando cambia el valor del input.
   **/
  onChange: PropTypes.func,
};

export default AutocompleteConnected;
